export const PAGE_TYPE = Object.freeze({
  HOME_PAGE: "home-page",
  SECTION_PAGE: "section-page",
  SUB_SECTION_PAGE: "sub-section-page",
  COLLECTION_PAGE: "collection-page",
  TAG_PAGE: "tag-page",
  CARTOON_PAGE: "cartoon-page",
  SEARCH_PAGE: "search-page",
  BOOKMARK_PAGE: "bookmark-page",
  STORY_PAGE: "story-page",
  AUTHORS_PAGE: "authors-page",
  AUTHOR_PAGE: "author-page",
  STORY_PUBLIC_PREVIEW_PAGE: "story-public-preview-page",
  CATALOG_PAGE: "catalog-page",
  STORY_PREVIEW: "story-preview",
  HOME_PREVIEW: "home-preview",
  STATIC_PAGE: "static-page",
  RESET_PASSWORD_PAGE: "reset-password-page",
  PROFILE_PAGE: "profile-page",
  USER_LOGIN: "user-login",
  VISUAL_STORY: "visual-story",
  HOROSCOPE_PAGE: "horoscope-page",
  INSTAGRAM_PAGE: "instagram-page",
  SUBSCRIBE_PAGE: "subscribe-page",
  PREMIUM_PAGE: "premium-page",
  SUBSCRIPTION_PAGE: "subscription-page"
});
export const TAG_PAGE_URL_PREFIX = "/tags/";
export const FOLLOW_US_TEXT = "ನಮ್ಮನ್ನು ಅನುಸರಿಸಿ";
export const AND_MORE_TEXT = "ಇನ್ನಷ್ಟು";
export const SEARCH_PLACEHOLDER = "ಪ್ರಜಾವಾಣಿಯಲ್ಲಿ ಹುಡುಕಿ...";
export const storyFields =
  "headline,id,subheadline,slug,seo,url,hero-image-s3-key,hero-image-caption,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,authors,author-name,author-id,sections,story-template,metadata,tags,read-time";

export const EPAPER_BANNER_TEXT = Object.freeze({
  HEADLINE: "ಯಾವಾಗಲಾದರೂ ಎಲ್ಲಿಯಾದರೂ", // Keeping for safety if used elsewhere or strict mapping
  SUBHEADLINE: "ಇಂದೇ ಹೆಚ್ಚು ಪರಿಷ್ಕೃತವಾಗಿರುವ ಇ-ಪೇಪರ್ ನ ಅನುಭವ ಪಡೆಯಿರಿ",
  BUTTON_MOBILE: "ಇ–ಪತ್ರಿಕೆ",
  BUTTON_DESKTOP: "ಇಂದಿನ ಇ-ಪತ್ರಿಕೆ ಓದಿ",
  PAPER_BANNER_HEADING_1: "ಯಾವಾಗಲಾದರೂ",
  PAPER_BANNER_HEADING_2: "ಎಲ್ಲಿಯಾದರೂ",
  PAPER_BANNER_SUBHEADING: "ಇಂದೇ ಹೆಚ್ಚು ಪರಿಷ್ಕೃ ತವಾಗಿರುವ ಇ-ಪೇಪರ್ ನ ಅನುಭವ ಪಡೆಯಿರಿ",
  PAPER_BANNER_CTA: "ಇಂದಿನ ಇ-ಪತ್ರಿಕೆ ಓದಿ",
  PAPER_BANNER_FEATURE_1_TITLE: "ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ಹುಡುಕಿ",
  PAPER_BANNER_FEATURE_1_SUBTITLE: "ಮತ್ತು ಹಂಚಿಕೊಳ್ಳಿ",
  PAPER_BANNER_FEATURE_2_TITLE: "ಬಳಕೆದಾರ ಸ್ನೇಹಿ",
  PAPER_BANNER_FEATURE_2_SUBTITLE: "ವಿನ್ಯಾಸ",
  PAPER_BANNER_FEATURE_3_TITLE: "ದಾಖಲೆಗಳನ್ನು",
  PAPER_BANNER_FEATURE_3_SUBTITLE: "ಪರಿಶೀಲಿಸಲು ಅನುಮತಿ"
});

export const COMMON_TEXT = Object.freeze({
  NO_RESULTS: "ಯಾವುದೇ ಫಲಿತಾಂಶಗಳು ಲಭ್ಯವಿಲ್ಲ"
});

export const FAQ_SECTION_HEADING = "ಸಾಮಾನ್ಯವಾಗಿ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು";
export const TESTIMONIALS_SECTION_HEADING = "ನಮ್ಮ ಓದುಗರು ಏನು ಹೇಳುತ್ತಾರೆ";
export const WHY_CHOOSE_SECTION_HEADING = "ಪ್ರಜಾವಾಣಿ ಪ್ರೀಮಿಯಂ ಆಯ್ಕೆ ಏಕೆ?";

export const SUBSCRIBE_PAGE_TEXT = Object.freeze({
  REVIEW_TITLE: "ಪರಿಶೀಲಿಸಿ ಮತ್ತು ಪಾವತಿಸಿ",
  EDIT: "ತಿದ್ದುಪಡಿ",
  START_DATE: "ಆರಂಭಿಕ ದಿನ: ",
  END_DATE: "ಕೊನೆಯ ದಿನಾಂಕ : ",
  AMOUNT_LABEL: "ಮೊತ್ತ",
  AMOUNT_TAX: "(ತೆರಿಗೆ ಒಳಗೊಂಡು)",
  RENEWAL_TEXT: "ಸ್ವಯಂಚಾಲಿತವಾಗಿ ನಿಮ್ಮ ಚಂದಾದಾರಿಕೆ ನವೀಕರಣಗೊಳ್ಳಲಿದೆ. ಯಾವುದೇ ಸಂದರ್ಭದಲ್ಲಿ ರದ್ದುಪಡಿಸಿ",
  PROCEED_TO_PAY: " ಪಾವತಿಸಲು ಮುಂದುವರಿಯಿರಿ",
  LOGIN_PREFIX: "ಲಾಗಿನ್ ಆಗಿರುವ ಖಾತೆ",
  CHANGE_ACCOUNT: "ಖಾತೆಯನ್ನು ಬದಲಾಯಿಸಿ",
  FAILURE_TITLE: "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ",
  FAILURE_MSG: "ನಿಮ್ಮ ಪಾವತಿಯು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೊಮ್ಮೆ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಅನ್ಯ ಮಾರ್ಗದ ಮೂಲಕ ಪ್ರಯತ್ನಿಸಿ",
  RETRY_CTA: "ಪಾವತಿಯನ್ನು ಮರುಪ್ರಯತ್ನಿಸಿ",
  REVIEW_CTA: "ಹಿಂದಕ್ಕೆ ತೆರಳಲು ಮತ್ತು ಪರಿಶೀಲನೆ",
  RETURN_LINK: "ಪ್ರಜಾವಾಣಿಗೆ ಮರಳಲು",
  CONTACT_PREFIX: "ಸಮಸ್ಯೆ ಎದುರಿಸುತ್ತಿದ್ದೀರಾ? ",
  CONTACT_SUFFIX: "ನಮ್ಮನ್ನುಸಂಪರ್ಕಿಸಿ",
  TIMING_TITLE: "ಕೆಲಸದ ಸಮಯ",
  TIMING_TEXT: "ಸೋಮವಾರದಿಂದ ಶುಕ್ರವಾರ: ಬೆಳಿಗ್ಗೆ 10ರಿಂದ ಸಂಜೆ 6",
  SUCCESS_TITLE: "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ",
  SUCCESS_SUBTITLE: "ಸ್ವಾಗತ! ನಿಮ್ಮ ಚಂದಾದಾರಿಕೆ ಈಗ ಸಕ್ರಿಯವಾಗಿದೆ",
  REDIRECT_PREFIX: "–ಸೆಕೆಂಡುಗಳಲ್ಲಿ ",
  REDIRECT_LINK_TEXT: "ಪ್ರಜಾವಾಣಿಗೆ",
  REDIRECT_SUFFIX: " ಮರುನಿರ್ದೇಶಸಲಾಗುತ್ತಿದೆ.",
  ACTIVE_PLAN: "ಹಾಲಿ ಯೋಜನೆ",
  UPGRADE_POPUP_TITLE: "ಉನ್ನತೀಕರಿಸುವ ಕೋರಿಕೆಯನ್ನು ಸ್ವೀಕರಿಸಲಾಗಿದೆ",
  UPGRADE_POPUP_MSG: "ಉನ್ನತೀಕರಿಸುವ ನಿಮ್ಮ ಕೋರಿಕೆಯು ನೋಂದಣಿಯಾಗಿದೆ. ಗ್ರಾಹಕರ ನೆರವಿನ ತಂಡವು ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಲಿದೆ. ಮುಂದಿನ 2ರಿಂದ 3 ಕಾರ್ಯನಿರ್ವಹಿಸುವ ದಿನಗಳಲ್ಲಿ ನಿಮ್ಮ ಯೋಜನೆ ಬದಲಾವಣೆ ಕುರಿತು ನಿಮಗೆ ನೆರವಾಗಲಿದ್ದಾರೆ.",
  UPGRADE_POPUP_BTN: "ಸರಿ",
  DOWNGRADE_POPUP_TITLE: "ಕೆಳದರ್ಜೆಗಿರಿಸುವ ಕೋರಿಕೆಯನ್ನು ಸ್ವೀಕರಿಸಲಾಗಿದೆ",
  DOWNGRADE_POPUP_MSG: "ನಿಮ್ಮ ಡೌನ್ಗ್ರೇಡ್ ವಿನಂತಿಯನ್ನು ದಾಖಲಿಸಿಕೊಳ್ಳಲಾಗಿದೆ. ನಿಮ್ಮ ಪ್ರಸಕ್ತ ಯೋಜನೆಯು [end date]. ಈ ದಿನಾಂಕದವರೆಗೂ ಸಕ್ರಿಯವಾಗಿ ಮುಂದುವರಿಯಲಿದೆ.ನಿಮ್ಮ ಹಾಲಿ ಯೋಜನೆ ಕೊನೆಗೊಂಡ ನಂತರವೇ ನೀವು ಹೊಸ ಯೋಜನೆಯನ್ನು ಖರೀದಿಸಲು ಸಾಧ್ಯ.",
  DOWNGRADE_POPUP_BTN: "ಸರಿ",
  RENEWAL_POPUP_TITLE: "ನಿಮ್ಮ ಚಂದಾದಾರಿಕೆ ಅವಧಿ ಕೊನೆಯಾಗಿದೆ!",
  RENEWAL_POPUP_SUBTITLE: "ತಡೆ ರಹಿತ ಪ್ರವೇಶದ ಮೂಲಕ ಗುಣಮಟ್ಟದ ಪತ್ರಿಕೋದ್ಯಮವನ್ನು ಸಂಭ್ರಮಿಸಿ",
  RENEWAL_POPUP_POINTS: [
    "ಎಲ್ಲಾ ಪ್ರೀಮಿಯಂ ಸುದ್ದಿಗಳಿಗೆ ಪ್ರವೇಶ",
    "ಇ–ಪೇಪರ್ ಪ್ರವೇಶ",
    "ಆ್ಯಡ್ ಲೈಟ್ ಅನುಭವ"
  ],
  RENEWAL_POPUP_BTN_PRIMARY: "ಈಗಲೇ ನವೀಕರಿಸಿ",
  RENEWAL_POPUP_BTN_SECONDARY: "ನಂತರ ನೆನಪಿಸಿ",
  AUTO_CANCEL_TITLE: "ನಿಮ್ಮ ಚಂದಾದಾರಿಕೆಯ ಸ್ವಯಂಚಾಲಿತ ನವೀಕರಣವನ್ನು<br/>ಸ್ಥಗಿತಗೊಳಿಸಲು ನೀವು ನಿಜವಾಗಿಯೂ<br/>ಬಯಸುತ್ತಿದ್ದೀರಾ?",
  AUTO_CANCEL_DROPDOWN_PLACEHOLDER: "ರದ್ದುಪಡಿಸಲು ಕಾರಣ*",
  AUTO_CANCEL_REASONS: [
    "ಇದು ನನಗೆ ತುಸು ದುಬಾರಿ.",
    "ನಾನು ನಿರೀಕ್ಷಿಸಿದಷ್ಟು ಮೌಲ್ಯ ನನಗೆ ದೊರೆಯುತ್ತಿಲ್ಲ.",
    "ನನಗೆ ಇತರ ಮೂಲಗಳಿಂದ ಸುದ್ದಿ ಸಿಗುತ್ತಿದೆ.",
    "ಅಂತರ್ಜಾಲ ಬಳಕೆ ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ.",
    "ಇತರೆ"
  ],
  AUTO_CANCEL_OTHER_PLACEHOLDER: "ಕಾರಣವನ್ನು ಇಲ್ಲಿ ನಮೂದಿಸಿ*",
  AUTO_CANCEL_INFO_TEXT: "ಸೂಚನೆ: ಹಾಲಿ ಅವಧಿ ಕೊನೆಗೊಳ್ಳುವವರೆಗೂ ನಿಮ್ಮ ಚಂದಾದಾರಿಕೆ ಸಕ್ರಿಯವಾಗಿರಲಿದೆ. ನಂತರ, ಇದು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ನವೀಕರಣಗೊಳ್ಳುವುದಿಲ್ಲ",
  AUTO_CANCEL_BTN_KEEP: "ಬೇಡ, ಸಕ್ರಿಯವಾಗಿಡಿ",
  AUTO_CANCEL_BTN_CANCEL: "ಹೌದು, ನವೀಕರಣ ರದ್ದುಪಡಿಸಿ",
  AUTO_CANCEL_ALERT_MSG: "Select a reason to continue.",
  AUTO_CANCEL_OTHER_ALERT_MSG: "Enter the reason to continue.",
  AUTORENEWAL_SUCCESS_TITLE: "ಸ್ವಯಂ ಚಾಲಿತ ನವೀಕರಣ ರದ್ದುಪಡಿಸಲಾಗಿದೆ.",
  AUTORENEWAL_SUCCESS_DESC: "ನಿಮ್ಮ ಚಂದಾದಾರಿಕೆಯ ಸ್ವಯಂ ಚಾಲಿತ ನವೀಕರಣವನ್ನು ನೀವು ಯಶಸ್ವಿಯಾಗಿ ರದ್ದುಪಡಿಸಿದ್ದೀರಿ. ಸದ್ಯ ಇರುವ ಯೋಜನೆಯಲ್ಲಿ ನಿಮ್ಮ ಪ್ರವೇಶವು [Expiry Date] ದಿನದವರೆಗೂ ಮುಂದುವರಿಯಲಿದೆ.",
  AUTORENEWAL_SUCCESS_BTN: "ಸರಿ"
});
export const SUBSCRIPTION_PAGE_STRINGS = {
  PV: {
    WHY_CHOOSE_HEADING: "ಪ್ರಜಾವಾಣಿಯೇ ಯಾಕೆ?",
    TESTIMONIALS_HEADING: "ನಮ್ಮ ಓದುಗರೇನು ಹೇಳುತ್ತಿದ್ದಾರೆ...",
    FAQ_HEADING: "ಪದೇ ಪದೇ ಕೇಳುವ ಪ್ರಶ್ನೆಗಳು",
    FOOTER_CONTACT_TITLE: "ಸಮಸ್ಯೆಯಿದೆಯೇ? ನಮ್ಮನ್ನು ಇಲ್ಲಿ ಸಂಪರ್ಕಿಸಿ:",
    WORKING_HOURS_LABEL: "ಕೆಲಸದ ಸಮಯ"
  }
};
